import createLucideIcon from '../createLucideIcon';

const MoveDownLeft = createLucideIcon('MoveDownLeft', [
  ['path', { d: 'M11 19H5V13', key: '1akmht' }],
  ['path', { d: 'M19 5L5 19', key: '72u4yj' }],
]);

export default MoveDownLeft;
